import { createFileRoute } from '@tanstack/react-router';

import { AbstractBrowse } from '@/module/Author/Abstract';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AbstractBrowse />;
}
